const shard6 = {
  // ── shared status / generic words ──────────────────────────────
  "Active": "सक्रिय",
  "Standby": "सज्ज",
  "Deployed": "तैनात",
  "deployed": "तैनात",
  "Monitor": "निरीक्षणाधीन",
  "OK": "ठीक",
  "Alert": "इशारा",
  "Ready": "सज्ज",
  "Armed": "सुसज्ज",
  "Stocked": "साठा उपलब्ध",
  "Sealed": "सीलबंद",
  "Live": "थेट",
  "LIVE": "थेट",
  "Online": "ऑनलाइन",
  "Showing": "दाखवत आहे",
  "most recent of": "पैकी अलीकडील",
  "AI events today": "आजच्या एआय घटना",
  "Offline": "ऑफलाइन",
  "Charging": "चार्जिंग सुरू",
  "Transit": "मार्गस्थ",
  "Low Bat": "कमी बॅटरी",
  "Under Inv.": "तपासाधीन",
  "Resolved": "निकाली",
  "Arrested": "अटक",
  "Verified": "सत्यापित",
  "Cleared": "निकाली काढले",
  "Actioned": "कार्यवाही झाली",
  "Low-conf": "कमी विश्वासार्हता",
  "Cognizable": "दखलपात्र",
  "Non-Cog": "अदखलपात्र",
  "Total": "एकूण",
  "total": "एकूण",
  "Zone": "झोन",
  "Status": "स्थिती",
  "Location": "स्थान",
  "Quantity": "प्रमाण",
  "Resource": "संसाधन",
  "available": "उपलब्ध",
  "members": "सदस्य",
  "Last action": "शेवटची कारवाई",
  "engines": "इंजिन",
  "staff": "कर्मचारी",
  "Valid": "वैध",
  "Current": "सद्य",
  "Alert Threshold": "इशारा मर्यादा",
  "Flood Level": "पूर पातळी",
  "Trigger": "कारण",
  "AI prob": "एआय संभाव्यता",
  "SOP Steps": "कार्यपद्धती पायऱ्या",
  "Resources Required": "आवश्यक संसाधने",
  "Evacuation Route": "निर्वासन मार्ग",
  "HIGH": "उच्च",
  "CRITICAL": "गंभीर",
  "AI": "एआय",
  "Complainant": "तक्रारदार",
  "Filed": "दाखल",
  "Closed": "बंद",
  "officers": "अधिकारी",
  "response": "प्रतिसाद",
  "sectors": "सेक्टर",
  "battery": "बॅटरी",
  "range": "पल्ला",
  "REC": "रेकॉर्डिंग",
  "Off": "बंद",
  "Sync": "सिंक",
  "Alt": "उंची",

  // ── Infrastructure-specific generic words ──────────────────────
  "Substation": "उपकेंद्र",
  "Load": "भार",
  "DG Backup": "डीजी बॅकअप",
  "Lighting": "प्रकाश व्यवस्था",
  "Alerts": "इशारे",
  "Backup": "बॅकअप",
  "tankers": "टँकर",
  "struct. score": "संरचना गुणांक",
  "System": "प्रणाली",
  "Fuel Level": "इंधन पातळी",
  "Est. Runtime": "अंदाजित चालण्याचा कालावधी",
  "Last Test": "शेवटची चाचणी",
  "kVA": "kVA",
  "Pressure": "दाब",
  "Flow": "प्रवाह",
  "Storage": "साठा",
  "None": "काही नाही",
  "Satellite": "उपग्रह",

  // ── Police-specific generic words ───────────────────────────────
  "AI Active": "एआय सक्रिय",
  "Resolution": "रिझोल्यूशन",
  "Coverage": "व्याप्ती",

  // ── place names ─────────────────────────────────────────────────
  "Ramkund Ghat": "रामकुंड घाट",
  "Ramkund": "रामकुंड",
  "Ramkund Zone A": "रामकुंड क्षेत्र अ",
  "Ramkund Entry 2": "रामकुंड प्रवेशद्वार 2",
  "Panchvati": "पंचवटी",
  "Panchvati S-7": "पंचवटी एस-7",
  "Trimbakeshwar": "त्र्यंबकेश्वर",
  "Trimbak": "त्र्यंबक",
  "Nashik": "नाशिक",
  "Nashik Road": "नाशिक रोड",
  "Nashik Urban": "नाशिक शहर",
  "Gangapur Camp": "गंगापूर कॅम्प",
  "Gangapur Dam area": "गंगापूर धरण परिसर",
  "Gangapur→Panchvati": "गंगापूर→पंचवटी",
  "Kalaram Temple": "काळाराम मंदिर",
  "Godavari Ghat": "गोदावरी घाट",
  "Camp Beta": "कॅम्प बीटा",
  "Camp 3 / OFZ-B": "कॅम्प 3 / OFZ-B",
  "EOC Reserve": "ईओसी राखीव",
  "EOC Base": "ईओसी तळ",
  "Traffic Junctions": "वाहतूक चौक",
  "Missing person zones": "बेपत्ता व्यक्ती क्षेत्रे",

  // ── DisasterManagement: SectionHeader / MetricCard / ChartCard ──
  "Disaster Management Command": "आपत्ती व्यवस्थापन कमांड",
  "NDRF & SDRF deployment · fire stations · search & rescue teams · Gangapur Dam monitoring · flood preparedness · pre-positioned resources · IMD weather alerts · disaster scenario SOPs — Maha AI · Simhastha 2027":
    "एनडीआरएफ व एसडीआरएफ तैनाती · अग्निशमन केंद्रे · शोध व बचाव तुकड्या · गंगापूर धरण निरीक्षण · पूर सज्जता · पूर्व-तैनात संसाधने · आयएमडी हवामान इशारे · आपत्ती परिस्थिती कार्यपद्धती — महा एआय · सिंहस्थ 2027",
  "NDRF LIVE": "एनडीआरएफ कार्यरत",
  "NDRF Platoons": "एनडीआरएफ प्लाटून",
  "Fire Stations": "अग्निशमन केंद्रे",
  "SAR Teams": "एसएआर तुकड्या",
  "Dam Level": "धरण पातळी",
  "Discharge": "विसर्ग",
  "Pre-Pos. Items": "पूर्व-तैनात वस्तू",
  "IMD Alerts": "आयएमडी इशारे",
  "3 Active": "3 सक्रिय",
  "5 Online": "5 ऑनलाइन",
  "4 Live": "4 कार्यरत",
  "244 cumecs": "244 क्युमेक्स",
  "10 Types": "10 प्रकार",
  "4 Active": "4 सक्रिय",
  "NDRF & SDRF Deployment Board": "एनडीआरएफ व एसडीआरएफ तैनाती फलक",
  "Platoon strength · zone · current task · readiness %": "प्लाटून संख्या · क्षेत्र · सद्य कार्य · सज्जता %",
  "Search & Rescue Teams": "शोध व बचाव तुकड्या",
  "4 specialised SAR teams · zone · equipment · status": "4 विशेष एसएआर तुकड्या · क्षेत्र · साधनसामग्री · स्थिती",
  "Fire Stations — Nashik & Trimbakeshwar": "अग्निशमन केंद्रे — नाशिक व त्र्यंबकेश्वर",
  "5 stations · engines · personnel · response time": "5 केंद्रे · इंजिन · कर्मचारी · प्रतिसाद वेळ",
  "Gangapur Dam — Level · Discharge · Inflow Forecast": "गंगापूर धरण — पातळी · विसर्ग · अंतर्वाह अंदाज",
  "Real-time dam level (%) · discharge (cumecs) · inflow trend — flood trigger at 95%": "रिअल-टाइम धरण पातळी (%) · विसर्ग (क्युमेक्स) · अंतर्वाह कल — 95% वर पूर ट्रिगर",
  "Pre-positioned Resources — Simhastha 2027": "पूर्व-तैनात संसाधने — सिंहस्थ 2027",
  "10 resource types · quantity · location · readiness status": "10 संसाधन प्रकार · प्रमाण · स्थान · सज्जता स्थिती",

  // ── DisasterManagement: banner / raw JSX text ───────────────────
  "MAHA AI — DISASTER MANAGEMENT COMMAND · NDRF 4TH BN OPERATIONAL": "महा एआय — आपत्ती व्यवस्थापन कमांड · एनडीआरएफ ४ थी बटालियन कार्यरत",
  "Disaster Management — Simhastha 2027": "आपत्ती व्यवस्थापन — सिंहस्थ 2027",
  "NDRF: 6 platoons/teams (3 active, 3 standby) · Fire: 5 stations, 12 engines · SAR: 4 teams deployed · Dam: 87% @ 244 cumecs ↑ · IMD: 1 Orange Watch · 3 scenarios pre-planned":
    "एनडीआरएफ: 6 प्लाटून/तुकड्या (3 सक्रिय, 3 प्रतीक्षारत) · अग्निशमन: 5 केंद्रे, 12 इंजिन · एसएआर: 4 तुकड्या तैनात · धरण: 87% @ 244 क्युमेक्स ↑ · आयएमडी: 1 ऑरेंज वॉच · 3 परिस्थिती पूर्व-नियोजित",
  "Disaster Scenario SOPs — Pre-Modelled": "आपत्ती परिस्थिती कार्यपद्धती — पूर्व-आराखडा तयार",
  "NDRF": "एनडीआरएफ",
  "Fire": "अग्निशमन",
  "SAR": "एसएआर",
  "Dam": "धरण",
  "Shelters": "निवारे",
  "6 Ready": "6 सज्ज",
  "5 Live": "5 कार्यरत",
  "Dam Level %": "धरण पातळी %",
  "Discharge (cumecs)": "विसर्ग (क्युमेक्स)",
  "Inflow (cumecs)": "अंतर्वाह (क्युमेक्स)",

  // ── NDRF platoons ────────────────────────────────────────────────
  "NDRF 4th Bn — Platoon Alpha": "एनडीआरएफ ४ थी बटालियन — प्लाटून अल्फा",
  "NDRF 4th Bn — Platoon Bravo": "एनडीआरएफ ४ थी बटालियन — प्लाटून ब्राव्हो",
  "NDRF 4th Bn — Platoon Charlie": "एनडीआरएफ ४ थी बटालियन — प्लाटून चार्ली",
  "NDRF 4th Bn — Platoon Delta": "एनडीआरएफ ४ थी बटालियन — प्लाटून डेल्टा",
  "Maharashtra SDRF — Team 1": "महाराष्ट्र एसडीआरएफ — तुकडी 1",
  "Maharashtra SDRF — Team 2": "महाराष्ट्र एसडीआरएफ — तुकडी 2",
  "Crowd support standby": "गर्दी सहाय्य प्रतीक्षारत",
  "Shelter overflow mgmt": "निवारा ओव्हरफ्लो व्यवस्थापन",
  "Flood pre-position": "पूर पूर्व-तैनाती",
  "River bank patrol": "नदीकाठ गस्त",
  "EOC standby": "ईओसी प्रतीक्षारत",
  "Crowd assistance": "गर्दी सहाय्य",

  // ── SAR teams ────────────────────────────────────────────────────
  "SAR Alpha — Water Rescue": "एसएआर अल्फा — जल बचाव",
  "SAR Bravo — Urban SAR": "एसएआर ब्राव्हो — शहरी एसएआर",
  "SAR Charlie — Medical SAR": "एसएआर चार्ली — वैद्यकीय एसएआर",
  "SAR Delta — Canine Unit": "एसएआर डेल्टा — श्वान पथक",
  "2 boats · life rings · scuba": "2 बोटी · लाइफ रिंग · स्कुबा",
  "Stretchers · harness · breacher": "स्ट्रेचर · हार्नेस · ब्रीचर",
  "ALS kit · oxygen · defibrillator": "एएलएस किट · ऑक्सिजन · डिफिब्रिलेटर",
  "2 trained dogs · GPS tracker": "2 प्रशिक्षित श्वान · जीपीएस ट्रॅकर",

  // ── Fire stations ────────────────────────────────────────────────
  "Nashik City FS": "नाशिक शहर अग्निशमन केंद्र",
  "Panchvati Fire Post": "पंचवटी अग्निशमन चौकी",
  "Trimbakeshwar FS": "त्र्यंबकेश्वर अग्निशमन केंद्र",
  "Nashik Road Post": "नाशिक रोड चौकी",
  "Gangapur Mobile Unit": "गंगापूर मोबाइल युनिट",

  // ── Disaster scenarios ───────────────────────────────────────────
  "Godavari Flash Flood": "गोदावरी अचानक पूर",
  "Mass Casualty Fire Event": "मोठ्या जीवितहानीची आग घटना",
  "Bridge / Structure Failure": "पूल / संरचना अपयश",
  "Dam level >90% + discharge >350 cumecs + rainfall >20mm/hr": "धरण पातळी >90% + विसर्ग >350 क्युमेक्स + पर्जन्य >20मिमी/तास",
  "Fire at camp / tent area with >50 persons": "50 पेक्षा जास्त व्यक्ती असलेल्या कॅम्प/तंबू क्षेत्रात आग",
  "Godavari Bridge structural alarm OR load >95% + vehicle overrun": "गोदावरी पूल संरचनात्मक इशारा किंवा भार >95% + वाहन ओव्हररन",
  "Issue evacuation advisory — all Ghats": "निर्वासन सूचना जारी करा — सर्व घाट",
  "Activate NDRF Platoon Charlie": "एनडीआरएफ प्लाटून चार्ली सक्रिय करा",
  "Close Godavari Bridge to pilgrims": "गोदावरी पूल यात्रेकरूंसाठी बंद करा",
  "Open OFZ-A overflow shelter": "OFZ-A ओव्हरफ्लो निवारा उघडा",
  "Deploy 2 rescue boats": "2 बचाव बोटी तैनात करा",
  "Alert nearest fire station": "जवळच्या अग्निशमन केंद्राला सतर्क करा",
  "Evacuate 100m radius": "100 मी परिघ निर्वासित करा",
  "NDRF SAR team deploy": "एनडीआरएफ एसएआर तुकडी तैनात करा",
  "Activate 3 ambulances": "3 रुग्णवाहिका सक्रिय करा",
  "Establish command post": "कमांड पोस्ट स्थापित करा",
  "Immediate closure — all traffic": "तात्काळ बंद — सर्व वाहतूक",
  "Evacuate bridge vicinity 200m": "पूल परिसर 200 मी निर्वासित करा",
  "NDRF urban SAR deploy": "एनडीआरएफ शहरी एसएआर तैनात करा",
  "Police cordon + divert": "पोलीस घेराव + वळण",
  "Structural engineer on-site within 30 min": "संरचना अभियंता 30 मिनिटांत घटनास्थळी",
  "NDRF-P3 (45 personnel)": "NDRF-P3 (45 जवान)",
  "2 rescue boats armed": "2 बचाव बोटी सुसज्ज",
  "4 overflow shelters ready": "4 ओव्हरफ्लो निवारे सज्ज",
  "Police cordoning team": "पोलीस घेराव तुकडी",
  "3 fire engines within 5 min": "3 अग्निशमन इंजिन 5 मिनिटांत",
  "NDRF SAR Alpha": "एनडीआरएफ एसएआर अल्फा",
  "4 ambulances": "4 रुग्णवाहिका",
  "Medical emergency team": "वैद्यकीय आपत्कालीन तुकडी",
  "NDRF SAR Bravo": "एनडीआरएफ एसएआर ब्राव्हो",
  "Police 3 platoons": "पोलीस 3 प्लाटून",
  "Civil engineering team": "स्थापत्य अभियांत्रिकी तुकडी",
  "2 cranes pre-positioned": "2 क्रेन पूर्व-तैनात",
  "Godavari Ghat → High Ground Via Camp Alpha": "गोदावरी घाट → उंच भाग कॅम्प अल्फा मार्गे",
  "Camp → Designated Assembly Point Zone D": "कॅम्प → नियुक्त संकलन बिंदू क्षेत्र D",
  "Divert via Nashik Road Flyover + Gangapur Causeway": "नाशिक रोड उड्डाणपूल + गंगापूर कॉजवे मार्गे वळवा",

  // ── Pre-positioned resources ─────────────────────────────────────
  "Rescue Boats": "बचाव बोटी",
  "Life Rings & Lines": "लाइफ रिंग व दोरखंड",
  "Emergency Shelters": "आपत्कालीन निवारे",
  "Portable Pumps": "पोर्टेबल पंप",
  "Generators (15 kVA)": "जनरेटर (15 केव्हीए)",
  "Stretcher Teams": "स्ट्रेचर तुकड्या",
  "Emergency Food Kits": "आपत्कालीन अन्न किट",
  "Inflatable Boats": "इन्फ्लेटेबल बोटी",
  "Body Bags": "बॉडी बॅग",
  "Chlorine Tablets": "क्लोरीन गोळ्या",
  "Godavari Ghat — Zone A": "गोदावरी घाट — क्षेत्र अ",
  "All 5 Ghats": "सर्व 5 घाट",
  "OFZ-A/B/C + 3 school camps": "OFZ-A/B/C + 3 शालेय कॅम्प",
  "Flood-prone zones": "पूरप्रवण क्षेत्रे",
  "All camp perimeters": "सर्व कॅम्प परिसर",
  "Medical posts + ghats": "वैद्यकीय चौक्या + घाट",
  "Camp Alpha / Beta / Delta": "कॅम्प अल्फा / बीटा / डेल्टा",
  "NDRF Platoon stores": "एनडीआरएफ प्लाटून भांडार",
  "Civil Hospital + EOC": "सिव्हिल हॉस्पिटल + ईओसी",
  "All water points": "सर्व जलस्रोत",

  // ── IMD alerts ───────────────────────────────────────────────────
  "Yellow Warning — Heavy Rain Nashik": "यलो चेतावणी — नाशिकमध्ये मुसळधार पाऊस",
  "Orange Watch — Flooding Godavari": "ऑरेंज वॉच — गोदावरी पूर",
  "Heat Advisory — Nashik District": "उष्णता सूचना — नाशिक जिल्हा",
  "Wind Speed Warning — Trimbakeshwar": "वाऱ्याचा वेग चेतावणी — त्र्यंबकेश्वर",

  // ── Infrastructure: SectionHeader / MetricCard / ChartCard ──────
  "Critical Infrastructure Resilience": "महत्त्वाच्या पायाभूत सुविधा सक्षमता",
  "Power grid · water supply network · comms backbone · bridge structural monitoring · backup systems · DG runtime · lighting grid — Maha AI · Simhastha Kumbh 2027":
    "वीज ग्रीड · पाणीपुरवठा नेटवर्क · दूरसंचार कणा · पूल संरचनात्मक निरीक्षण · बॅकअप यंत्रणा · डीजी चालण्याचा कालावधी · प्रकाश व्यवस्था — महा एआय · सिंहस्थ कुंभ 2027",
  "2 ALERTS": "2 इशारे",
  "Power Grid": "वीज ग्रीड",
  "Water Supply": "पाणीपुरवठा",
  "Comms": "संपर्क",
  "Bridges": "पूल",
  "Water Pressure": "पाणी दाब",
  "Comms Uptime": "दूरसंचार अपटाइम",
  "Bridges OK": "पूल ठीक",
  "Light Grid": "प्रकाश ग्रीड",
  "Water Alerts": "पाणी इशारे",
  "VSAT Links": "व्हीसॅट लिंक",
  "6 Armed": "6 सुसज्ज",
  "3.2 bar": "3.2 बार",
  "2 Live": "2 कार्यरत",
  "Power Grid — Zone Status": "वीज ग्रीड — क्षेत्र स्थिती",
  "MSEDCL substation load · DG backup armed · lighting poles — all 6 zones": "एमएसईडीसीएल उपकेंद्र भार · डीजी बॅकअप सुसज्ज · प्रकाश खांब — सर्व 6 क्षेत्रे",
  "Power Load Trend — Zones (% of Capacity)": "वीज भार कल — क्षेत्रे (क्षमतेच्या %)",
  "Hourly load tracking — alert triggers if any zone exceeds 90%": "तासागणिक भार मागोवा — कोणतेही क्षेत्र 90% पेक्षा जास्त झाल्यास इशारा",
  "Water Supply Network — 8 Pumping Stations": "पाणीपुरवठा नेटवर्क — 8 पंपिंग स्टेशन",
  "Pressure · flow rate · storage level · tankers assigned per station": "दाब · प्रवाह दर · साठा पातळी · प्रति केंद्र नेमलेले टँकर",
  "Communications Backbone — Tower Status": "दूरसंचार कणा — टॉवर स्थिती",
  "BSNL 4G · Maha Kumbh AI VSAT · Police P25 · Health VHF — uptime and load": "बीएसएनएल 4G · महा कुंभ एआय व्हीसॅट · पोलीस P25 · आरोग्य VHF — अपटाइम व भार",
  "Bridge Structural Monitor": "पूल संरचनात्मक निरीक्षण",
  "Load vs capacity · structural integrity score · last inspection date": "भार वि. क्षमता · संरचनात्मक मजबुती गुणांक · शेवटच्या तपासणीची तारीख",
  "Backup Power Systems — DG & UPS Status": "बॅकअप वीज यंत्रणा — डीजी व यूपीएस स्थिती",
  "Diesel generator fuel level · estimated runtime · kVA rating per zone": "डिझेल जनरेटर इंधन पातळी · अंदाजित चालण्याचा कालावधी · प्रति क्षेत्र केव्हीए क्षमता",
  "Power Grid Health": "वीज ग्रीड आरोग्य",
  "Water Supply Health": "पाणीपुरवठा आरोग्य",
  "Comms Health": "दूरसंचार आरोग्य",
  "Bridges Health": "पूल आरोग्य",

  // ── Infrastructure: banner / raw JSX text ────────────────────────
  "MAHA AI — INFRASTRUCTURE RESILIENCE COMMAND · 6 ZONES · 2 ALERTS": "महा एआय — पायाभूत सुविधा सक्षमता कमांड · 6 क्षेत्रे · 2 इशारे",
  "Critical Infrastructure — Simhastha 2027": "महत्त्वाच्या पायाभूत सुविधा — सिंहस्थ 2027",
  // Banner sentence is now built from live-computed fragments (see
  // Infrastructure.jsx) instead of one hand-typed sentence with numbers
  // baked in, so each phrase below is a standalone reusable term.
  "Power": "वीज",
  "Water": "पाणी",
  "zones monitored (load >80%)": "क्षेत्रे निरीक्षणाधीन (भार >80%)",
  "station alerts": "केंद्र इशारे",
  "towers live": "टॉवर कार्यरत",
  "uptime": "अपटाइम",
  "monitored": "निरीक्षणाधीन",
  "DG backups armed": "डीजी बॅकअप सुसज्ज",
  "VSAT EOC live": "व्हीसॅट ईओसी कार्यरत",

  // ── Power / water / comms / bridges data ─────────────────────────
  "Pump Stn 1 — Gangapur Dam": "पंप स्टेशन 1 — गंगापूर धरण",
  "Pump Stn 2 — Panchvati": "पंप स्टेशन 2 — पंचवटी",
  "Pump Stn 3 — Ramkund": "पंप स्टेशन 3 — रामकुंड",
  "Pump Stn 4 — Trimbak Zone": "पंप स्टेशन 4 — त्र्यंबक क्षेत्र",
  "Pump Stn 5 — Nashik Road": "पंप स्टेशन 5 — नाशिक रोड",
  "Pump Stn 6 — Camp Network": "पंप स्टेशन 6 — कॅम्प नेटवर्क",
  "Pump Stn 7 — Kalaram": "पंप स्टेशन 7 — काळाराम",
  "Pump Stn 8 — Panchvati N": "पंप स्टेशन 8 — पंचवटी उत्तर",
  "Godavari Bridge (Main)": "गोदावरी पूल (मुख्य)",
  "Trimbak Naka Overpass": "त्र्यंबक नाका उड्डाणपूल",
  "Panchvati Foot Bridge": "पंचवटी पादचारी पूल",
  "Nashik Road Flyover": "नाशिक रोड उड्डाणपूल",
  "Gangapur Causeway": "गंगापूर कॉजवे",
  "Monitor — >80% load": "निरीक्षणाधीन — >80% भार",
  "DG-R1 Ramkund": "DG-R1 रामकुंड",
  "DG-P1 Panchvati": "DG-P1 पंचवटी",
  "DG-T1 Trimbak": "DG-T1 त्र्यंबक",
  "DG-N1 Nashik Rd": "DG-N1 नाशिक रोड",
  "VSAT EOC": "VSAT ईओसी",
  "EOC UPS Array": "ईओसी यूपीएस अ‍ॅरे",

  // ── PoliceModernization: SectionHeader / MetricCard / ChartCard ─
  "Police Modernization Hub": "पोलीस आधुनिकीकरण केंद्र",
  "Smart CCTV surveillance · UAV drone fleet · body cameras · digital FIR management · QRT rapid response · AI-powered crowd analytics · patrol coverage · technology modernization — Maha AI · Simhastha 2027":
    "स्मार्ट सीसीटीव्ही निगराणी · यूएव्ही ड्रोन ताफा · बॉडी कॅमेरे · डिजिटल एफआयआर व्यवस्थापन · क्यूआरटी जलद प्रतिसाद · एआय-आधारित गर्दी विश्लेषण · गस्त व्याप्ती · तंत्रज्ञान आधुनिकीकरण — महा एआय · सिंहस्थ 2027",
  "290 CAMS LIVE": "290 कॅमेरे कार्यरत",
  "CCTV Online": "सीसीटीव्ही ऑनलाइन",
  "Drones Active": "ड्रोन सक्रिय",
  "Body Cams": "बॉडी कॅम",
  "QRT Teams": "क्यूआरटी तुकड्या",
  "FIR Today": "आजचे एफआयआर",
  "AI Events": "एआय घटना",
  "Patrol Coverage": "गस्त व्याप्ती",
  "Arrests Today": "आजच्या अटक",
  "CCTV Surveillance Network — Zone Status": "सीसीटीव्ही निगराणी नेटवर्क — क्षेत्र स्थिती",
  "290 cameras · 7 zones · AI-active cameras · alerts per zone": "290 कॅमेरे · 7 क्षेत्रे · एआय-सक्रिय कॅमेरे · प्रति क्षेत्र इशारे",
  "UAV Drone Fleet — Live Status": "यूएव्ही ड्रोन ताफा — प्रत्यक्ष स्थिती",
  "6 drones · zone · battery · task · operator": "6 ड्रोन · क्षेत्र · बॅटरी · कार्य · संचालक",
  "Body Camera Status — Key Officers": "बॉडी कॅमेरा स्थिती — प्रमुख अधिकारी",
  "6 body cams · recording status · battery · storage · last sync": "6 बॉडी कॅम · रेकॉर्डिंग स्थिती · बॅटरी · साठवण · शेवटचे सिंक",
  "Quick Response Team (QRT) Board": "जलद प्रतिसाद तुकडी (क्यूआरटी) फलक",
  "5 QRT teams · strength · vehicle · ETA · zone": "5 क्यूआरटी तुकड्या · संख्या · वाहन · ईटीए · क्षेत्र",
  "Zone Patrol Coverage": "क्षेत्र गस्त व्याप्ती",
  "Officer deployment vs sector coverage across all 6 zones": "सर्व 6 क्षेत्रांमध्ये अधिकारी तैनाती वि. सेक्टर व्याप्ती",
  "AI Surveillance Events — Recent": "एआय निगराणी घटना — अलीकडील",
  "AI-flagged events · confidence · assigned officer · status": "एआय-चिन्हांकित घटना · विश्वासार्हता · नेमलेला अधिकारी · स्थिती",
  "Digital FIR Management — Today's Cases": "डिजिटल एफआयआर व्यवस्थापन — आजची प्रकरणे",
  "All FIRs filed digitally — type · crime · status": "सर्व एफआयआर डिजिटल पद्धतीने दाखल — प्रकार · गुन्हा · स्थिती",
  "FIR Volume Trend — Today": "एफआयआर प्रमाण कल — आज",
  "Hourly FIR filing vs closures": "तासागणिक एफआयआर नोंदणी वि. निकाली",

  // ── Police: banner / raw JSX text ────────────────────────────────
  "MAHA AI — POLICE MODERNIZATION HUB · SP NASHIK · 6,420 DEPLOYED": "महा एआय — पोलीस आधुनिकीकरण केंद्र · एसपी नाशिक · 6,420 तैनात",
  "Smart Policing — Simhastha Kumbh 2027": "स्मार्ट पोलिसिंग — सिंहस्थ कुंभ 2027",
  "290 CCTV cameras (285 live) · 6 drones (5 active) · 6 body cams · 5 QRT teams · 228 AI events today · 88% patrol coverage · 2 arrests · 5 digital FIRs":
    "290 सीसीटीव्ही कॅमेरे (285 कार्यरत) · 6 ड्रोन (5 सक्रिय) · 6 बॉडी कॅम · 5 क्यूआरटी तुकड्या · आज 228 एआय घटना · 88% गस्त व्याप्ती · 2 अटक · 5 डिजिटल एफआयआर",
  "AI face recognition — DPDP 2023 compliant · No punitive action without human officer approval · Crowd analytics only at aggregate level":
    "एआय चेहरा ओळख — डीपीडीपी 2023 अनुरूप · मानवी अधिकाऱ्याच्या मंजुरीशिवाय कोणतीही दंडात्मक कारवाई नाही · गर्दी विश्लेषण केवळ एकत्रित स्तरावर",
  "Body cam footage stored encrypted for 30 days · DPDP 2023 compliant · Access requires DCP authorisation":
    "बॉडी कॅम फुटेज 30 दिवस एन्क्रिप्टेड स्वरूपात साठवले जाते · डीपीडीपी 2023 अनुरूप · प्रवेशासाठी डीसीपी अधिकृतता आवश्यक",
  "All AI flags require human officer verification before action — DPDP 2023 · Human-in-loop mandatory":
    "कारवाईपूर्वी सर्व एआय फ्लॅगना मानवी अधिकाऱ्याची पडताळणी आवश्यक — डीपीडीपी 2023 · मानवी सहभाग अनिवार्य",

  // ── AI radar / CCTV / drones / body cams / QRT / patrol data ────
  "CCTV Coverage": "सीसीटीव्ही व्याप्ती",
  "Drone Uptime": "ड्रोन अपटाइम",
  "Body Cam Active": "बॉडी कॅम सक्रिय",
  "Digital FIR": "डिजिटल एफआयआर",
  "QRT Readiness": "क्यूआरटी सज्जता",
  "Aerial Patrol": "हवाई गस्त",
  "Crowd Monitor": "गर्दी निरीक्षण",
  "Traffic Watch": "वाहतूक निरीक्षण",
  "Area Survey": "क्षेत्र सर्वेक्षण",
  "4K thermal": "4K थर्मल",
  "2K zoom": "2K झूम",
  "QRT Alpha — Ramkund": "क्यूआरटी अल्फा — रामकुंड",
  "QRT Bravo — Panchvati": "क्यूआरटी ब्राव्हो — पंचवटी",
  "QRT Charlie — Trimbak": "क्यूआरटी चार्ली — त्र्यंबक",
  "QRT Delta — Nashik Rd": "क्यूआरटी डेल्टा — नाशिक रोड",
  "QRT Echo — Mobile": "क्यूआरटी इको — मोबाइल",
  "QRT Bravo": "क्यूआरटी ब्राव्हो",
  "PCR Van + Bike": "पीसीआर व्हॅन + बाईक",
  "PCR Van": "पीसीआर व्हॅन",
  "PCR Van + Jeep": "पीसीआर व्हॅन + जीप",
  "Bike Squad (4)": "बाईक पथक (4)",
  "Bus + PCR Van": "बस + पीसीआर व्हॅन",

  // ── AI events / digital FIR data ──────────────────────────────────
  "Crowd density alert — Ramkund Entry 2": "गर्दी घनता इशारा — रामकुंड प्रवेशद्वार 2",
  "Unattended bag — Panchvati Zone 3": "अनाथ बॅग — पंचवटी क्षेत्र 3",
  "Face match — Missing child MP-1185": "चेहरा जुळणी — बेपत्ता मूल MP-1185",
  "Aggressive crowd behavior — Zone A5": "आक्रमक गर्दी वर्तन — क्षेत्र A5",
  "Vehicle obstruction — Trimbak Road": "वाहन अडथळा — त्र्यंबक रोड",
  "Perimeter breach — Camp B restricted": "सीमा भंग — कॅम्प B प्रतिबंधित क्षेत्र",
  "Sent to DCP": "डीसीपींकडे पाठवले",
  "Traffic officer": "वाहतूक अधिकारी",
  "Theft at Camp Alpha": "कॅम्प अल्फा येथे चोरी",
  "Minor dispute — Ghat area": "किरकोळ वाद — घाट परिसर",
  "Pickpocketing — Entry 2": "खिसेकापू घटना — प्रवेशद्वार 2",
  "Missing person — MP-1185": "बेपत्ता व्यक्ती — MP-1185",
  "Impersonation — volunteer": "स्वयंसेवक तोतयागिरी",
};

export default shard6;
